import dayjs from "dayjs";
import { ProductTestStatusEnum } from "@/types/enums";
import type { ProductTest } from "@/types/product-test";

/**
 * How long a test has been running past its expected return, as a human readable duration.
 *
 * Whether a test IS late is decided by the server and published as `status`: `late` depends on
 * the current time, and each client evaluating it against its own clock would disagree. This
 * only formats the gap, which is a rendering concern.
 */
const productTestLateBy = function (
  productTest: Pick<ProductTest, "status" | "expected_at">,
): string | null {
  if (productTest.status !== ProductTestStatusEnum.LATE || !productTest.expected_at) {
    return null;
  }

  return dayjs().from(dayjs(productTest.expected_at), true);
};

export { productTestLateBy };
